/* istanbul ignore file */
import React from 'react';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewJournalEntryButton = (props: any) => {
  const { getSingleEntityUrl } = useJournalEntryUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-journal-entry" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewJournalEntryButton;
